<template>
  <div class="modal-sprinkler-container">
    <div class="sprinkler-header">SPRINKLER</div>
    <div class="modal-sprinkler-headers">
      <div class="sprinkler-box-spacer"></div>
      <div class="modal-sprinkler-classifications-box">
        <p class="modal-sprinkler-title">SPRINKLER</p>
        <div class="modal-sprinkler-item" v-for="sprinkler, index in sprinklers" :key="index"
          @click="this.handleSprinkler(sprinkler)" :style="this.handleBackground(sprinkler.id, this.sprinkler.id)"
          :id="sprinkler.name">
          <div v-if="sprinkler.id === this.sprinkler.id" class="arrow-right"></div>
          <p data-testid="modal-sprinkler" class="modal-sprinkler-text">{{ sprinkler.name }}</p>
        </div>
      </div>
      <div class="modal-sprinkler-classifications-box">
        <p class="modal-sprinkler-title">MODEL</p>
        <div class="modal-sprinkler-item" v-for="model, index in models" :key="index" @click="this.handleModel(model)"
          :style="this.handleBackground(model.id, this.model.id)" :id="model.name">
          <div v-if="model.id === this.model.id" class="arrow-right"></div>
          <p class="modal-sprinkler-text  model-item">{{ model.name }}</p>
        </div>
      </div>
      <div class="modal-sprinkler-classifications-box">
        <p class="modal-sprinkler-title">PLATE</p>
        <div class="modal-sprinkler-item" v-for="plate, index in plates" :key="index" @click="this.handlePlate(plate)"
          :style="this.handleBackground(plate.id, this.plate.id)" :id="plate.name">
          <div v-if="plate.id === this.plate.id" class="arrow-right"></div>
          <p class="modal-sprinkler-text">{{ plate.name + ' ' + plate.trajectory }}°</p>
        </div>
      </div>
      <div class="modal-sprinkler-classifications-box last-box">
        <p class="modal-sprinkler-title">NOZZLES</p>
        <div class="modal-sprinkler-item" v-for="nozzle, index in nozzles" :key="index"
          @click="this.handleNozzle(nozzle)" :style="this.handleBackground(nozzle.id, this.nozzle.id)"
          :id="'nozzle-' + nozzle.id">
          <div v-if="nozzle.id === this.nozzle.id" class="arrow-right"></div>
          <p class="modal-sprinkler-text nozzle-item">{{ nozzle.name }}</p>
        </div>
      </div>
      <div class="sprinkler-box-spacer spacer-right"></div>
    </div>
    <div class="sprinkler-warning-box">
      <div class="sprinkler-warning-cont" v-if="isWarn">
        <h3 class="sprinkler-warning-title">Missing Values</h3>
        <div class="sprinkler-warning-inner-cont">
          <p class="sprinkler-warning-subtitle">Please select these items: </p>
          <ul class="sprinkler-warn-list-box">
            <li class="sprinkler-warn-values" v-for="item in missingValues"> {{ item }} </li>
          </ul>
          <button class="ms-sprinkler-btn" @click="handleConfirm">Ok</button>
        </div>
      </div>
    </div>
    <div class="modal-sprinkler-button-holder">
      <div id="ms-save" class="save-btn" @click="this.hideModal">DONE</div>
    </div>
  </div>
</template>

<script>
import { useInputStore } from '@/store/InputStore.js';
import { useModalStore } from '../store/ModalStore.js';
import { useSprinklerStore } from '../store/SprinklerStore.js';

export default {
  mounted () {
    const sprinklerStore = useSprinklerStore();
    this.sprinkler.name = sprinklerStore.getSprinklerSelected;
    this.model.name = sprinklerStore.getSelectedModel;
    this.plate.name = sprinklerStore.getSelectedPlate;
    this.nozzle.name = sprinklerStore.getSelectedNozzle;
    this.sprinkler.id = sprinklerStore.getSprinklerSelectedId;
    this.model.id = sprinklerStore.getModelSelectedId;
    this.plate.id = sprinklerStore.getPlateSelectedId;
    this.nozzle.id = sprinklerStore.getNozzleSelectedId;
    this.savedNozzleId = sprinklerStore.getNozzleSelectedId;
  },
  computed: {
    sprinklers () {
      return useSprinklerStore().getSprinklers;
    },
    models () {
      return useSprinklerStore().getModels;
    },
    plates () {
      return useSprinklerStore().getPlates;
    },
    nozzles () {
      return useSprinklerStore().getNozzles;
    },
  },
  data () {
    return {
      sprinkler: {
        id: null,
        name: null
      },
      model: {
        id: null,
        name: null
      },
      connection: {
        id: null,
        name: null
      },
      plate: {
        id: null,
        name: null
      },
      nozzle: {
        id: null,
        name: null
      },
      isWarn: false,
      missingValues: []
    };
  },
  methods: {
    handleBackground (name, selected) {
      if (selected === name) {
        return {
          'background-color': '#FFFFFF'
        };
      } else {
        return {
          'background-color': '#F2F2F2'
        };
      }
    },
    handleSprinkler (sprinkler) {
      const sprinklerStore = useSprinklerStore();
      sprinklerStore.setModels(null);
      this.model.id = null;
      this.model.name = null;
      sprinklerStore.setPlates(null);
      this.plate.id = null;
      this.plate.name = null;
      sprinklerStore.setNozzles(null);
      this.nozzle.id = null;
      this.nozzle.name = null;
      sprinklerStore.fetchModels(sprinkler.id)
        .then(() => {
          if (sprinklerStore.getModels.length === 1) {
            this.model.name = this.models[0].name;
            this.model.id = this.models[0].id;
            sprinklerStore.fetchPlates(this.models[0].id);
          }
        });
      this.sprinkler.id = sprinkler.id;
      this.sprinkler.name = sprinkler.name;
    },
    handleModel (model) {
      const sprinklerStore = useSprinklerStore();
      sprinklerStore.setPlates(null);
      this.plate.id = null;
      this.plate.name = null;
      sprinklerStore.setNozzles(null);
      this.nozzle.id = null;
      this.nozzle.name = null;
      sprinklerStore.fetchPlates(model.id)
        .then(() => {
          if (this.plates.length === 1) {
            this.plate.name = this.plates[0].name;
            this.plate.id = this.plates[0].id;
            sprinklerStore.fetchNozzles(this.plate[0].id);
          }
        });
      this.model.id = model.id;
      this.model.name = model.name;
    },
    handleConnection (connection) {
      this.connection.id = connection.id;
      this.connection.name = connection.name;
    },
    handlePlate (plate) {
      const sprinklerStore = useSprinklerStore();
      sprinklerStore.setNozzles(null);
      this.nozzle.id = null;
      this.nozzle.name = null;
      sprinklerStore.fetchNozzles(plate.id)
        .then(() => {
          if (this.nozzles.length === 1) {
            this.nozzle.name = this.nozzles[0].name;
            this.nozzle.id = this.nozzles[0].id;
          }
        });
      this.plate.id = plate.id;
      this.plate.name = JSON.stringify(plate.name + ' ' + plate.trajectory + '°');
    },
    
    handleNozzle (nozzle) {
      this.nozzle.id = nozzle.id;
      this.nozzle.name = nozzle.name;
    },
    handleModalCancel () {
      const modalStore = useModalStore();
      modalStore.hideModal();
      modalStore.showModal('sprinklers');
    },

    hideModal () {
      if (this.nozzle.id != null && this.plate.id != null && this.model.id != null && this.sprinkler.id != null) {
        const sprinklerStore = useSprinklerStore();
        sprinklerStore.setSelection(this.sprinkler, this.model, this.plate, this.nozzle);
        useInputStore().sprinklerCalc();
        useModalStore().hideModal();
      } else {
        this.isWarn = true;
        this.missingValues = [];
        if (this.sprinkler.id === null) {
          this.missingValues.push('Sprinkler');
        }
        if (this.model.id === null) {
          this.missingValues.push('Model');
        }
        if (this.plate.id === null) {
          this.missingValues.push('Plate');
        }
        if (this.nozzle.id === null) {
          this.missingValues.push('Nozzle');
        }
      }
    },
    handleConfirm () {
      this.isWarn = this.isWarn ? false : true; 
    }
  }
};
</script>

<style scoped>
.modal-sprinkler-container {
  background-color: whitesmoke;
  text-align: left;
}
.modal-sprinkler-headers {
  display: flex;
  flex-direction: row;
}
.modal-sprinkler-classifications-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-right: 1px solid #4d4d4d;
  border-top: 1px solid #4d4d4d;
  border-bottom: 1px solid #4d4d4d;
  max-height: 350px;
  min-height: 350px;
  overflow-y: auto;
  min-width: 100px;
}
.modal-sprinkler-text {
  padding: 0 1rem;
  margin: 0;
}
.modal-sprinkler-title {
  padding: 0 1rem;
  margin: 8px 0;
  font-size: 78%;
  font-weight: bold;
}
.modal-sprinkler-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 0;
  cursor: pointer;
  font-size: 85%;
  font-weight: 500;
}
.modal-sprinkler-button {
  margin: 5px;
  padding: 10px 25px;
  color: white;
  font-weight: 700;
  font-size: .9em;
  text-transform: uppercase;
  cursor: pointer;
  background-color: var(--nelson-green);
  border: none;
}
.modal-sprinkler-button-holder {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 10px;
}
.arrow-right {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid var(--nelson-blue);
}
.sprinkler-header {
  padding: 15px;
  font-size: 90%;
  font-weight: bold;
}
.model-item {
  font-weight: 800;
}
.nozzle-item {
  font-weight: 600;
  font-size: 95%;
  height: 20px;
}
.last-box {
  border-right: none;
  min-width: 220px;
}
.sprinkler-box-spacer {
  width: 8px;
  border-right: 1px solid #4d4d4d;
  border-top: 1px solid #4d4d4d;
  border-bottom: 1px solid #4d4d4d;
}
.spacer-right {
  border-left: 1px solid #4d4d4d;
  border-right: none;
}
.ms-sprinkler-btn {
  border: none;
  cursor: pointer;
  background-color: var(--nelson-green);
  color: white;
  height: 35px;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: 900;
  letter-spacing: 0.05em;
}
.sprinkler-warning-box {
  display: flex;
  flex-direction: row;
  align-items: end;
  justify-content: center;
}
.sprinkler-warning-cont {
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  width: 250px;
  height: 175px;
  padding-bottom: 10px;
  margin-bottom: 20px;
  border: 1px solid black;
}
.sprinkler-warning-title {
  padding: 0px 0px 0px 10px;
  margin: 0px;
}
.sprinkler-warn-list-box {
  list-style-type: none;
  padding: 0px;
}
.sprinkler-warn-values {
  font-size: 12px;
  font-weight: bold;
}
.sprinkler-warning-subtitle{
  padding: 10px 0px 0px 0px;
  margin: 0px;
}
.sprinkler-warning-inner-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>